/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_NotesInputs */

const vi_common_notes = /** @type {(inputs: Common_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú`)
};

/**

* @param {Common_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_notes = /** @type {((inputs?: Common_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_notes(inputs)
});